import theme from '../../layout/Theme';
import giftCardLeft from '../../../assets/images/giftCardLeft.png';
import giftCardMediumLeft from '../../../assets/images/giftCardMediumLeft.png';
import giftCardRight from '../../../assets/images/giftCardRight.png';
import giftCardMediumRight from '../../../assets/images/giftCardMediumRight.png';
import giftCardSmall from '../../../assets/images/giftCardSmall.png';

const styles = (materialTheme) => ({
  mainParentBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  upperBox: {
    background: materialTheme.palette.primary.main,
    color: materialTheme.palette.common.white,
  },
  giftCardBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  giftCardSubBox: {
    width: '50%',
    [theme.screenSize.laptop]: {
      width: '80%',
    },
    [theme.screenSize.smallestScreen]: {
      width: '100%',
    },
  },
  firstHeading: {
    fontWeight: 600,
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
  },
  secondHeading: {
    fontSize: theme.font.size.xl7,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '24px',
    [theme.screenSize.laptop]: {
      fontSize: theme.font.size.xl4,
    },
  },
  thirdHeading: {
    fontSize: theme.font.size.xl,
    fontWeight: 400,
    marginBottom: '40px',
    textAlign: 'center',
    [theme.screenSize.laptop]: {
      width: '100%',
    },
  },
  giftButtons: {
    display: 'flex',
    justifyContent: 'center',
    [theme.screenSize.laptop]: {
      width: '100%',
    },
  },
  innerButton: {
    background: 'white',
    marginBottom: '24px',
    padding: '16px',
    minWidth: '200px',
    '&:hover': {
      backgroundColor: theme.colors.secondaryBackground,
    },
    [theme.screenSize.smallestScreen]: {
      width: '100%',
    },
  },
  lowerBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  innerLowerBox: {
    width: '80%',
    marginTop: '32px',
    [theme.screenSize.smallestScreen]: {
      width: '100%',
      margin: '8px 8px',
    },
  },
  lowerBoxImage: {
    display: 'flex',
    justifyContent: 'center',
    '& img': {
      width: '120px',
      height: '120px',
      objectFit: 'contain',
    },
  },
  lowerBoxTitle: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    fontSize: theme.font.size.xl,
    fontWeight: '600',
    lineHeight: '30px',
    marginTop: '20px',
  },
  lowerBoxText: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: theme.font.size.md,
    lineHeight: '24px',
    fontWeight: '400',
  },
  questionMainHeading: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
    fontSize: theme.font.size.xl4,
    fontWeight: '700',
    [theme.screenSize.smallestScreen]: {
      fontSize: theme.font.size.xl3,
      padding: '0px 50px',
    },
  },
  questionSubHeading: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '40px',
    fontSize: theme.font.size.xl,
    fontWeight: '400',
    color: materialTheme.palette.primary.dark,
    [theme.screenSize.smallestScreen]: {
      fontSize: theme.font.size.md,
      padding: '0px 50px',
    },
  },
  questionBox: {
    width: '50%',
    [theme.screenSize.laptop]: {
      width: '86%',
    },
    [theme.screenSize.smallestScreen]: {
      width: '100%',
    },
  },
  questionParent: {
    display: 'flex',
    justifyContent: 'center',
  },
  emailInnerButton: {
    background: materialTheme.palette.primary.main,
    marginBottom: '24px',
    color: 'white',
    padding: '8px',
    '&:hover': {
      background: materialTheme.palette.primary.main,
    },
    width: '16%',
    [theme.screenSize.middleWidth]: {
      width: '100%',
    },
  },
  emailButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
    [theme.screenSize.laptop]: {
      width: '100%',
    },
  },
  stillQuestion: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.font.size.xl,
    marginTop: '24px',
    marginBottom: '3px',
    [theme.screenSize.laptop]: {
      fontSize: theme.font.size.xl3,
    },
    [theme.screenSize.smallestScreen]: {
      fontSize: theme.font.size.xl3,
      marginBottom: '10px',
      marginLeft: '90px',
    },
  },
  lastBoxParent: {
    width: '75%',
    background: theme.colors.dark11,
    borderRadius: '16px',
    [theme.screenSize.laptop]: {
      width: '90%',
    },
  },
  subParentLastBox: {
    width: '50%',
    [theme.screenSize.laptop]: {
      width: '90%',
    },
  },
  cardLeft: {
    position: 'absolute',
    width: '556px',
    height: '459px',
    background: `url(${giftCardLeft})`,
    [theme.screenSize.laptop]: {
      position: 'absolute',
      width: '287px',
      height: '237px',
      background: `url(${giftCardMediumLeft})`,
    },
    [theme.screenSize.extraSmallScreen]: {
      display: 'none',
    },
  },
  cardRight: {
    position: 'absolute',
    width: '556px',
    height: '464px',
    right: '0px',
    background: `url(${giftCardRight})`,
    [theme.screenSize.laptop]: {
      position: 'absolute',
      right: '0px',
      width: '287px',
      height: '237px',
      background: `url(${giftCardMediumRight})`,
    },
    [theme.screenSize.extraSmallScreen]: {
      display: 'none',
    },
  },
  giftCardAnimationDesktop: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    '& img': {
      maxWidth: '800px',
      width: '100%',
      height: 'auto',
    },
    [theme.screenSize.laptop]: {
      display: 'none',
    },
  },
  giftCardAnimationMedium: {
    display: 'none',
    [theme.screenSize.laptop]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      '& img': {
        maxWidth: '500px',
        width: '100%',
        height: 'auto',
      },
    },
  },
  giftCardSmall: {
    [theme.screenSize.extraSmallScreen]: {
      width: '100%',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      height: '309px',
      background: `url(${giftCardSmall})`,
    },
  },
  giftCardParent: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '464px',
    [theme.screenSize.laptop]: {
      minHeight: '237px',
    },
    [theme.screenSize.extraSmallScreen]: {
      minHeight: '310px',
    },
  },
  backgroundSection: {
    position: 'relative',
  },
  orText: {
    fontSize: theme.font.size.md,
    fontWeight: 400,
    color: materialTheme.palette.common.white,
    textAlign: 'center',
  },
  redeemCardContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '-148px',
    zIndex: 10,
    [theme.screenSize.laptop]: {
      marginTop: '-148px',
    },
    [theme.screenSize.smallestScreen]: {
      marginTop: '-152px',
      padding: '0 15px',
    },
  },
  redeemCardBox: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '600px',
    [theme.screenSize.laptop]: {
      maxWidth: '500px',
    },
    [theme.screenSize.smallestScreen]: {
      maxWidth: '100%',
    },
  },
  redeemCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    border: '1px solid lightgrey',
    padding: '32px',
    width: '100%',
    backgroundColor: materialTheme.palette.common.white,
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    [theme.screenSize.smallestScreen]: {
      padding: '24px',
      gap: '24px',
    },
  },
  redeemTitle: {
    fontSize: theme.font.size.xl,
    fontWeight: theme.font.weight.semibold,
    color: materialTheme.palette.primary.main,
    textAlign: 'center',
  },
  redeemDescription: {
    fontSize: theme.font.size.sm,
    color: materialTheme.palette.text.secondary,
    textAlign: 'center',
  },
  gcCodeField: {
    height: '48px',
    borderRadius: '8px',
    backgroundColor: materialTheme.palette.common.white,

    '&.MuiOutlinedInput-root.Mui-focused': {
      boxShadow: 'none',
      borderColor: theme.colors.success.main,
    },

    '& .MuiOutlinedInput-input': {
      fontSize: theme.font.size.sm,
      lineHeight: theme.font.lineHeight.sm,

      '&::placeholder': {
        fontWeight: theme.font.weight.medium,
        color: `${theme.colors.lightGray3} !important`,
        opacity: '.8 !important',
      },
    },
  },
  inputButtonRow: {
    display: 'flex',
    gap: '12px',
    marginTop: '8px',
    alignItems: 'flex-start',
    [theme.screenSize.smallestScreen]: {
      flexDirection: 'column',
      gap: '8px',
    },
  },
  gcCodeInput: {
    flex: 1,
    [theme.screenSize.smallestScreen]: {
      width: '100%',
    },
  },
  redeemButton: {
    minWidth: '120px',
    height: '48px',
    [theme.screenSize.smallestScreen]: {
      width: '100%',
    },
  },
  signInBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    textAlign: 'center',
    padding: '24px',
    border: `1px solid ${theme.colors.blue500}`,
    borderRadius: '8px',
    backgroundColor: theme.colors.white12,
  },
  signInTitle: {
    fontSize: theme.font.size.lg,
    fontWeight: theme.font.weight.medium,
    color: theme.colors.blue500,
  },
  signInSubtitle: {
    fontSize: theme.font.size.sm,
    color: materialTheme.palette.primary.dark,
    lineHeight: theme.font.lineHeight.md,
  },
  signInButton: {
    minWidth: '200px',
    marginTop: '8px',
  },
});

export default styles;
